
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dFOTO", function(module, exports) {

$parcel$export(module.exports, "EditorClassificationTagWrapper", () => $d6adb75da3f1528c$export$1ea7d51d1b0f817f);
/* EditorClassificationTagWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $9wGTI = parcelRequire("9wGTI");

var $2JKSZ = parcelRequire("2JKSZ");

var $d58Kh = parcelRequire("d58Kh");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6adb75da3f1528c$var$ClassificationTagPlaceholder = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4t3i1ou6",
            __cmplp.className
        ])
    });
});
const $d6adb75da3f1528c$var$contentTypeClassificationStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.025'
});
const $d6adb75da3f1528c$export$1ea7d51d1b0f817f = ({ isDataClassificationEnabledForOrg: isDataClassificationEnabledForOrg, spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, hasEditPermission: hasEditPermission, isLivePage: isLivePage, userOffline: userOffline, shouldRenderPlaceholder: shouldRenderPlaceholder })=>{
    if (!isDataClassificationEnabledForOrg) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            !(0, $9wGTI.fg)('confluence_modernized_breadcrumbs') && $d6adb75da3f1528c$var$contentTypeClassificationStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2JKSZ.ContentTypeClassification), {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        contentClassificationMetadata: contentClassificationMetadata,
        readOnly: !hasEditPermission
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "content-classification-tag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d58Kh.EditorContentClassificationTag), {
        contentId: contentId,
        contentType: contentType,
        contentClassificationMetadata: contentClassificationMetadata,
        isEditMode: true,
        customSitesTitleComponent: true,
        spaceKey: spaceKey,
        userOffline: userOffline
    })), shouldRenderPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d6adb75da3f1528c$var$ClassificationTagPlaceholder, null));
};

});


//# sourceMappingURL=EditorClassificationTagWrapper.f24b8d90.js.map
